function setAdminLoggedIn (token, email) {
  window.localStorage.setItem('adminToken', 'Bearer ' + token)
  window.localStorage.setItem('adminEmail', email)
}

export default setAdminLoggedIn
